module.exports = __webpack_public_path__ + "static/14-20bce9ac9f642f0e485d1e94c7ff3df5.png";